import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { SortOptionShape } from '../Infrastructure/propShapes';
import { currentSortBy } from '../Infrastructure/pagination';
import { translateResourceString } from '../../util/translationUtility';

class SortByDropdown extends React.Component {
    constructor(props) {
        super(props)

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    render() {
        const { sortOptions, onCurrentSortByChange } = this.props;
        if(sortOptions == null || sortOptions.length === 0) { return; }

        const selectedSort = currentSortBy(sortOptions);
        const title = <span>{translateResourceString("/Search/SortBy")} {selectedSort.displayName} <i className="fa fa-angle-down" /></span>;
        return (
            <Dropdown
                isOpen={this.state.dropdownOpen}
                toggle={this.toggle}
                id="sort-by-dropdown"
                className="sort-by"
            >
                <DropdownToggle
                    color="neogen-light-gray"
                    className="sort-by__toggle"
                >
                    {title}
                </DropdownToggle>
                <DropdownMenu className="sort-by__menu">
                    {sortOptions.map((option, i) => {
                        return (
                            <DropdownItem
                                key={option.name}
                                active={option.selected}
                                className="sort-by__item"
                                onClick={() => onCurrentSortByChange(option.name)}
                            >
                                {option.displayName}
                            </DropdownItem>
                        );
                    })

                    }
                </DropdownMenu>
            </Dropdown>
        );
    }
};

SortByDropdown.propTypes = {
    sortOptions: PropTypes.arrayOf(PropTypes.shape(SortOptionShape)),
    onCurrentSortByChange: PropTypes.func
}

export default SortByDropdown;